import * as signalR from '@microsoft/signalr';

const API_URL = import.meta.env.VITE_API_URL || '';

export interface SyncProgressMessage {
  current: number;
  total: number;
  percent: number;
  currentEmployee?: string;
  status: 'syncing' | 'completed' | 'error';
}

class SignalRService {
  private connection: signalR.HubConnection | null = null;
  private sessionId: string | null = null;

  async connect(): Promise<string> {
    // Benzersiz session ID olustur
    this.sessionId = `sync_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${API_URL}/hubs/sync-progress`)
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    await this.connection.start();

    // Session grubuna katil
    await this.connection.invoke('JoinSyncGroup', this.sessionId);

    console.log('SignalR connected, sessionId:', this.sessionId);
    return this.sessionId;
  }

  onProgress(callback: (message: SyncProgressMessage) => void): void {
    if (this.connection) {
      this.connection.on('SyncProgress', callback);
    }
  }

  offProgress(): void {
    if (this.connection) {
      this.connection.off('SyncProgress');
    }
  }

  async disconnect(): Promise<void> {
    if (this.connection && this.sessionId) {
      try {
        await this.connection.invoke('LeaveSyncGroup', this.sessionId);
        await this.connection.stop();
      } catch (e) {
        console.error('SignalR disconnect error:', e);
      }
      this.connection = null;
      this.sessionId = null;
    }
  }

  getSessionId(): string | null {
    return this.sessionId;
  }

  isConnected(): boolean {
    return this.connection?.state === signalR.HubConnectionState.Connected;
  }
}

export const signalRService = new SignalRService();
export default signalRService;
